import { forwardRef } from "react"
import Slide from "@mui/material/Slide"

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="left" ref={ref} {...props} />
})

export default Transition
